import { React } from 'react';

export default function ComingSoon(props) {
    let featureDescription = "This feature will be completed as soon as possible";
    if (props.desc !== undefined) {
        featureDescription = props.desc;
    }
    return(
        <div>
        <h1><center>Coming Soon!</center></h1>
        <p>
        <h3><center>{featureDescription}</center></h3>
        </p>
        </div>
    )
}